import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Icon = ({ prefix, icon, ...props }) => <FontAwesomeIcon icon={[prefix, icon]} {...props} />;

Icon.propTypes = {
  prefix: PropTypes.string,
  icon: PropTypes.string,
};

Icon.defaultProps = {};

export default Icon;
